import { BaseModel } from '@tcc-mono/shared/data-access';

export class SetupCode extends BaseModel {
  id: number;
  code: string;
  value: number;
}
